import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import vuetify from './plugins/vuetify'

document.querySelectorAll('.lightning-model-page').forEach(element => {
  const app = createApp(App, {
    accountId: element.getAttribute('data-account-id'),
  })

  // app.use(router)
  app.use(vuetify)
  app.use(createPinia())

  app.mount(element)
})
